import React, { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useOutletContext, useSearchParams } from 'react-router-dom';

import { setRegisterToken } from '@/store/company/actions';
import { actualLoginRegisterRestore, externalLogin, registerUserData } from '@/store/login/actions';
import { getUser } from '@/store/users/actions';

import { selectCompany } from '@/store/company/selectors';

import { Button, Form, Input, Spin } from 'antd';
import LogoCompany from '@/components/LogoCompany';

import { AUTH_TYPES } from '@shared/pages/Login/constants';

import classNames from 'classnames';
import _get from 'lodash/get';

import css from './Login.module.scss';

const RegistrationPageData = () => {
  const { /*imageBackgroundLogin,*/ imageLogo, navigate } = useOutletContext();
  const { t } = useTranslation('registrationData');
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const { registerToken } = useSelector(selectCompany);

  const [isLoading, setLoading] = useState(true);

  const handleChangeRenderPage = formData => {
    dispatch(
      registerUserData(formData.name, formData.lastName, registerToken, response => {
        localStorage.setItem('authorizationToken', response.accessToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('expiresIn', response.expiresIn);
        localStorage.setItem('expiresTime', response.expiresIn * 1000 + Date.now());

        dispatch(
          getUser(
            {
              onSuccess: response => {
                const isExternalLogin =
                  _get(response, 'domainCompany.providers', []).filter(provider => provider.type === AUTH_TYPES.OAUTH)
                    .length > 0;

                if (isExternalLogin) {
                  localStorage.setItem('externalLogin', 'true');
                } else {
                  localStorage.removeItem('externalLogin');
                }

                dispatch(externalLogin());
                navigate('/personal-data/registration-page-data-about');
              },
            },
            response.accessToken
          )
        );
      })
    );
  };

  const isKampus = document.location.hostname === 'td.kampus.team';

  useLayoutEffect(() => {
    const refreshToken = searchParams.get('token');
    const registerToken = `Bearer ${refreshToken}`;

    dispatch(
      actualLoginRegisterRestore(
        registerToken,
        () => {
          dispatch(setRegisterToken(registerToken));
          setLoading(false);
        },
        () => {
          navigate(`/user-login/auth-fail`);
        }
      )
    );
  }, []);

  return (
    <Spin spinning={isLoading} className={css['App-card-item']}>
      {/* <img className={css.imageBackgroundLogin} src={imageBackgroundLogin} alt='' /> */}
      <Form className={css['LoginPage-form']} onFinish={handleChangeRenderPage}>
        <div className={css['LoginPage-form__contentRegistrationData']}>
          <div className={css['LoginPage-header']}>
            <div className={css['LoginPage-header__logo']}>
              <LogoCompany imageLogo={imageLogo} />
            </div>
          </div>
          <div className={classNames(css['LoginPage-titleHead'], css['LoginPage-titleHead-modificate'])}>
            {t('welcome')}
          </div>
          <div className={classNames(css['LoginPage-titleBody'], css['LoginPage-titleBody-headBlock'])}>
            {isKampus ? t('descriptionKampus') : t('description1')}
            <br />
            {!isKampus && t('description2')}
          </div>
          {!isKampus && (
            <div className={classNames(css['LoginPage-titleBody'], css['LoginPage-titleBody-bodyBlock'])}>
              {t('myName')}
            </div>
          )}
          <Form.Item
            colon={false}
            name='name'
            className={css['LoginPage-form-itemRegistrationData']}
            validateFirst={true}
            rules={[
              {
                required: true,
                message: t('wrongRequired'),
              },
            ]}
          >
            <Input placeholder={t('name')} size='large' data-qa='registartionNameInput' />
          </Form.Item>
          <Form.Item
            colon={false}
            name='lastName'
            className={css['LoginPage-form-itemRegistrationData']}
            validateFirst={true}
            rules={[
              {
                required: true,
                message: t('wrongRequired'),
              },
            ]}
          >
            <Input placeholder={t('surname')} size='large' data-qa='registartionSurnameInput' />
          </Form.Item>
          {!isKampus && (
            <div className={classNames(css['LoginPage-form-line'], css['LoginPage-form-line-modificate'])} />
          )}
          <Form.Item className={css['LoginPage-form-google']}>
            <Button size='large' type='primary' htmlType='submit' data-qa='registartionNextButton'>
              {t('next')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Spin>
  );
};

export default RegistrationPageData;
